<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
      :cols="columnas"
    ></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "texto",
        label: "Texto Menú",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "texto",
      },
      {
        key: "sistema",
        label: "Sistema",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "sistema",
      },
      {
        key: "ruta",
        label: "Ruta",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "ruta",
      },
      {
        key: "icono",
        label: "Icono",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "icono",
      },
      {
        key: "orden",
        label: "Orden",
        busqueda: "",
        tipo: "number",
        searchable: true,
        path: "orden",
      },
      {
        key: "debajo_de",
        label: "Debajo De",
        busqueda: "",
        tipo: "select",
        searchable: true,
        path: "debajo_de_texto",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "texto",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "texto",
        key: "texto",
        valor: "",
        label: "Texto Menú (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "sistema",
        valor: "",
        label: "Sistema (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "ruta",
        valor: "",
        label: "Ruta (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "icono",
        valor: "",
        label: "Icono (*)",
        disabled: false,
      },
      {
        cols: 6,
        tipo: "numero",
        key: "orden",
        valor: "",
        label: "Orden (*)",
        disabled: false,
      },
      {
        cols: 6,
        tipo: "select",
        key: "debajo_de",
        valor: "",
        label: "Debajo De (*)",
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre_sistema",
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Menu",
      ancho: "lg",
      ruta: "/menus",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Menus",
      titulo_boton: "Crear Menu",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    menus: [],
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }

    this.cargar_menus();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_menus() {
      await this.axios
        .get(`${this.api}/menus?limit=99999`, this.cabeceras_json)
        .then((res) => {
          this.menus = res.data.data.data;
          this.columnas[5].opciones = this.menus;
          this.inputs[5].opciones = this.menus;
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },

    async cargar($event) {
      this.pagina_actual = `${this.api}/menus${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/menus${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/menus`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });

      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/menus/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>